export const QUEUE_CHAT_MESSAGES          = '/user/exchange/amq.direct/chat.messages';
export const QUEUE_API_RESPONSES          = '/user/exchange/amq.direct/apiResponses';
export const QUEUE_EVENT_NOTIFICATIONS    = '/user/exchange/amq.direct/event.notifications';

// Topic subscriptions
export const TOPIC                        = '/topic';
export const CHANNEL                      = '/channel';
// Ex channel endpoint with chatId of  '/topic/channel.1'
export const TOPIC_CHANNEL                = `${TOPIC}${CHANNEL}`;